import React from 'react';

import { ContentBlockList } from './ContentBlockList';

export interface ContentBlockProps {
    features?: Array<{ 
        id?: string | number; 
        title?: string; 
        description?: string; 
        linkUrl?: string 
    }>;
    buttonLabel?: string;
}

const ContentBlock = ({ features = [], buttonLabel }: ContentBlockProps) => {
    if (!features.length) return null;
    return (
        <div className="w-full bg-white py-12 md:py-[72px] px-4 md:px-12 lg:px-[94px] flex flex-col items-center">
            <ContentBlockList features={features} buttonLabel={buttonLabel} />
        </div>
    );
};

export default ContentBlock;
